/**
 * Event Bus (factory function)
 *
 * A lightweight in-process event bus for SDK events.
 * No Node.js `events` dependency — runs natively in the browser.
 */

import {OdysseyEvent} from "../types/events";

export interface EventBus {
  on(event: OdysseyEvent, listener: (...args: any[]) => void): void;
  off(event: OdysseyEvent, listener: (...args: any[]) => void): void;
  emit(event: OdysseyEvent, ...args: any[]): void;
  removeAllListeners(event?: OdysseyEvent): void;
}

export function createEventBus(): EventBus {
  const listeners = new Map<string, Set<(...args: any[]) => void>>();

  function on(event: OdysseyEvent, listener: (...args: any[]) => void): void {
    let set = listeners.get(event);
    if (!set) {
      set = new Set();
      listeners.set(event, set);
    }
    set.add(listener);
  }

  function off(event: OdysseyEvent, listener: (...args: any[]) => void): void {
    listeners.get(event)?.delete(listener);
  }

  function emit(event: OdysseyEvent, ...args: any[]): void {
    listeners.get(event)?.forEach((fn) => fn(...args));
  }

  function removeAllListeners(event?: OdysseyEvent): void {
    if (event) {
      listeners.delete(event);
    } else {
      listeners.clear();
    }
  }

  return {on, off, emit, removeAllListeners};
}
